"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinDeductibleTravelExpenses = exports.getReducedGrossPrice = exports.roundDownCentsToFullHundreds = exports.VAT_RATE = exports.CAR_TYPE_COST_VALUE = void 0;
const _1 = require(".");
exports.CAR_TYPE_COST_VALUE = {
    [_1.CarType.ICE]: 1,
    [_1.CarType.HYBRID]: 0.5,
    [_1.CarType.EV]: 0.25,
};
exports.VAT_RATE = 0.19;
const COMMUTE_DISTANCE_DEFAULT_PRICE_LIMIT = 20;
// Rates are in cents
const DEFAULT_COMMUTE_PRICE_RATE = 30;
const COMMUTE_PRICE_RATE_OVER_DEFAULTS_LIMIT = 35;
const COMMUTE_PRICE_RATE_OVER_DEFAULTS_LIMIT_AFTER_2021 = 38;
const LAST_YEAR_WITHOUT_RATE_CHANGES = 2020;
const getCommutePriceRateOverDefaultsLimit = (declarationYear) => declarationYear > 2021
    ? COMMUTE_PRICE_RATE_OVER_DEFAULTS_LIMIT_AFTER_2021
    : COMMUTE_PRICE_RATE_OVER_DEFAULTS_LIMIT;
/**
 * Floors (rounds) the value to the nearest hundreds.
 * (E.g amount = 144505 [EUR 1445.05] results in 140000 [EUR 1400])
 */
const roundDownCentsToFullHundreds = (amountInCents) => {
    // Convert price to Euros.
    const amountInEuros = amountInCents / 100;
    // Floor the price divided by 100 and then multiply it again by 100 to get a
    // value rounded to closest smallest hundreds.
    const roundedAmountInEuros = Math.floor(amountInEuros / 100) * 100;
    // Return the result converted back to cents
    return roundedAmountInEuros * 100;
};
exports.roundDownCentsToFullHundreds = roundDownCentsToFullHundreds;
/**
 * Reduces the gross price based on the car type and floors (rounds) the value to the nearest hundreds.
 */
const getReducedGrossPrice = ({ grossPriceInCents, carType, }) => {
    // Reduce the price based on the car type
    const reducedPriceInCents = grossPriceInCents * exports.CAR_TYPE_COST_VALUE[carType];
    return (0, exports.roundDownCentsToFullHundreds)(reducedPriceInCents);
};
exports.getReducedGrossPrice = getReducedGrossPrice;
/**
 * Returns the minimum deductible travel expenses based on the commute days and distance.
 * If distance is minor or equal to a established limit all the calculation is based on
 * one fixed rate. If the distance exceeds that limit, the exceeding distance is calculated
 * with a slightly higher rate.
 */
const getMinDeductibleTravelExpenses = ({ commuteDays, commuteDistance, declarationYear, }) => {
    if (commuteDays === 0 || commuteDistance === 0) {
        return 0;
    }
    if (declarationYear <= LAST_YEAR_WITHOUT_RATE_CHANGES ||
        commuteDistance <= COMMUTE_DISTANCE_DEFAULT_PRICE_LIMIT) {
        return commuteDays * commuteDistance * DEFAULT_COMMUTE_PRICE_RATE;
    }
    const distanceOverLimit = commuteDistance - COMMUTE_DISTANCE_DEFAULT_PRICE_LIMIT;
    const amountUnderDistanceLimit = commuteDays * COMMUTE_DISTANCE_DEFAULT_PRICE_LIMIT * DEFAULT_COMMUTE_PRICE_RATE;
    const amountOverDistanceLimit = commuteDays * distanceOverLimit * getCommutePriceRateOverDefaultsLimit(declarationYear);
    return Math.round(amountUnderDistanceLimit + amountOverDistanceLimit);
};
exports.getMinDeductibleTravelExpenses = getMinDeductibleTravelExpenses;
//# sourceMappingURL=utils.js.map